/* eslint-disable */

<template>
  <div>

    <vue-sortable :options="options" @drag:start="startedDrag" @drag:stop="stoppedDrag" @sortable:sort="sort">
      <div class="vx-row " :class="{'cursor-drag' : draggingCard === true}">
        <div class="vx-col lg:w-3/12 md:w-3/12 sm:w-5/5">
          <vx-card class="mb-base">
            <h3 class="font-bold mb-4">Controls</h3>
            <vue-draggable-container id="wordBank" class="wordBank">
              <h5 class="dragBlock my-1 font-semibold cursor-pointer" v-for="i in controls" :key="i">{{i}}</h5>
            </vue-draggable-container>
          </vx-card>
        </div>
        <div class="vx-col lg:w-9/12 md:w-9/12 sm:w-5/5">
          <vx-card class="mb-base">
            <div class="fourth-sim pt-0">
              <div class="vx-row mb-4">
                <div class="vx-col w-1/2 flex items-center">
                  <h2 class="font-bold">Question</h2>
                </div>
                <div class="vx-col w-1/2 flex items-center">
                  <h2 class="font-bold">Answer</h2>
                </div>
              </div>
              <div class="vx-row border-white border-2 border-solid rounded p-4 my-6">
                <div class="vx-col w-1/2 flex items-center">
                  <h4 class="font-semibold">The DB server can only be managed from NIC3 via RDP from the sysadmin 10.100.2.0/24 network.</h4>
                </div>
                <div class="vx-col w-1/2">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg "
                                           id="input0">

                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white border-2 border-solid rounded p-4 my-6">
                <div class="vx-col w-1/2 flex items-center">
                  <h4 class="font-semibold">The web server in the 10.10.10.0/25 network should connect to the DB via NIC1</h4>
                </div>
                <div class="vx-col w-1/2">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg "
                                           id="input1">

                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white border-2 border-solid rounded p-4 my-6">
                <div class="vx-col w-1/2 flex items-center">
                  <h4 class="font-semibold">The backup server at 172.30.10.3 should perform DB backups by connecting via the 192.168.1.20/24 network.</h4>
                </div>
                <div class="vx-col w-1/2">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg "
                                           id="input2">

                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white border-2 border-solid rounded p-4 my-6">
                <div class="vx-col w-1/2 flex items-center">
                  <h4 class="font-semibold">The DB server should not initiate outbound connections on NIC2</h4>
                </div>
                <div class="vx-col w-1/2">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg "
                                           id="input3">

                  </vue-draggable-container>
                </div>
              </div>
              <div class="flex items-center justify-center">
                <img src="https://cdn.discordapp.com/attachments/746242308084858900/850470475251580939/unknown.png" alt="" draggable="false">
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </vue-sortable>

  </div>
</template>

<script>

import draggable from 'vuedraggable'
import Prism from 'vue-prism-component'
import shuffle from 'shuffle-array'

export default {
  data () {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,

      controls: [
        'Permit UDP from 192.168.1.20 to 172.30.10.3',
        'Deny TCP from 10.0.10.20/24 to ANY',
        'Permit IP from 172.30.10.3 to 10.100.2.0',
        'Permit IP from 172.30.10.3 to 10.100.2.0',
        'Permit TCP from 10.100.2.0/24 to 172.16.0.20/24 port 1433',
        'Permit TCP from 172.16.0.20/32 to 10.10.10.0/25 port 1433',
        'Permit TCP from 10.100.2.0/24 to 172.16.0.20/32 port 3389',
        'Permit TCP from 10.10.10.0/24 to 192.168.1.20/24 port 1433',
        'Permit IP from 172.30.10.3 to 192.168.1.20',
        'Deny IP from 10.0.10.20 to ANY'
      ],

      options: {
        draggable: '.dragBlock',
        dropzone: '.dropzoneStandard'
      }
    }
  },
  methods: {
    startedDrag (x) {
      x.data.source.className += ' currently-dragging-standard'
      this.draggingCard = true
    },
    stoppedDrag () {
      this.draggingCard = false
    },
    sort (x) {
      const overContainer = x.data.dragEvent.data.overContainer
      const sourceContainer = x.data.dragEvent.data.sourceContainer
      if (overContainer && overContainer.id !== 'wordBank' && overContainer.children) {
        if (overContainer.children.length > 0 && overContainer.id !== sourceContainer.id) {
          //this.drag_error()
          x.cancel()
        }
      }
    },
    markSimulation () {

      let total_score = 0

      if (document.getElementById('input0').textContent === 'Permit TCP from 10.100.2.0/24 to 172.16.0.20/32 port 3389') {
        document.getElementById('input0').style.borderColor = '#28C76F'
        document.getElementById('input0').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input0').style.borderColor = '#fd4445'
        document.getElementById('input0').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input1').textContent  === 'Permit TCP from 10.10.10.0/24 to 192.168.1.20/24 port 1433') {
        document.getElementById('input1').style.borderColor = '#28C76F'
        document.getElementById('input1').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input1').style.borderColor = '#fd4445'
        document.getElementById('input1').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input2').textContent  === 'Permit IP from 172.30.10.3 to 192.168.1.20') {
        document.getElementById('input2').style.borderColor = '#28C76F'
        document.getElementById('input2').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input2').style.borderColor = '#fd4445'
        document.getElementById('input2').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input3').textContent  === 'Deny IP from 10.0.10.20 to ANY') {
        document.getElementById('input3').style.borderColor = '#28C76F'
        document.getElementById('input3').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input3').style.borderColor = '#fd4445'
        document.getElementById('input3').style.backgroundColor = '#fd4445'
      }

      if (total_score === this.dataLocal.legacy.total_score) {
        return this.$emit('simulation_full_correct', total_score)
      }

      this.$emit('simulation_getting_there', total_score)

    }

  },
  components: {
    draggable,
    Prism,
    shuffle
  },
  created () {
    this.controls = shuffle(this.controls)
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  }

}
</script>

